<template>
  <el-aside style="background-color: #ffffff; color: #6d6d6d; width: 100%">
    <vue-scroll>
      <div class="menu-padding">
        <el-menu
          :popper-append-to-body="true"
          :collapse-transition="false"
          :class="[
            this.$i18n.locale == 'en_US'
              ? config.sysversion == '2.0'
                ? 'el-menu-vertical-demo'
                : 'el-menu-vertical-demo-3'
              : config.sysversion == '2.0'
              ? 'el-menu-vertical-demo1'
              : 'el-menu-vertical-demo1-3',
            collapse ? 'el-menu-close' : 'el-menu-open'
          ]"
          :router="true"
          :collapse="collapse"
          :unique-opened="true"
          ref="elMenu"
          :default-active="$route.path"
          :style="collapse ? 'width: 60px;' : this.$i18n.locale !== 'zh_CN' ? 'width:220px' : 'width: 182px;'"
        >
          <div
            class="el-logo"
            style="background-color: #ffffff; color: #360d09; text-wrap: nowrap; font-weight: bold; font-size: 17px"
          >
            {{ $t("aside.title") }}
          </div>
          <sidebar-item v-for="item in this.routes" :key="item.id" :item="item"></sidebar-item>
        </el-menu>
      </div>
    </vue-scroll>
  </el-aside>
</template>
<script>
  import lineUtil from "@/utils/humpToLine";
  import sidebarItem from "./SidebarItem";
  import config from "@/http/config";
  export default {
    name: "Aside",
    components: {
      sidebarItem
    },
    data() {
      return {
        index: "",
        config: config
      };
    },
    watch: {
      $route(to) {
        if (to.path === "/main") {
          this.close(this.index);
        }
      }
    },
    methods: {
      close(index) {
        this.$refs.elMenu.close(index);
      },
      url(str) {
        return lineUtil.toLine(str);
      }
    },
    computed: {
      routes() {
        return this.$store.state.menuList;
      },
      collapse() {
        return this.$store.state.collapse;
      }
    }
  };
</script>

<style lang="scss">
  .el-menu--vertical {
    .el-menu-item,
    .el-submenu__title {
      height: 35px;
      line-height: 36px;
      i {
        width: 24px;
        text-align: center;
        font-size: 15px;
        vertical-align: middle;
        margin-right: 8px !important;
      }
    }

    .el-menu-item:hover,
    .el-submenu__title:hover {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      i {
        color: #ffffff !important;
      }

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(0, 21, 41, 1) !important;
      // i {
      //     color: #ffffff !important;
      // }
    }

    .is-active {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(24, 144, 255, 1) !important;
    }

    .is-active:hover {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(24, 144, 255, 1) !important;
    }

    .el-menu--popup {
      min-width: 160px !important;
      border-radius: 3px;
    }
  }

  .el-submenu__icon-arrow {
    font-weight: bold;
  }
</style>
